
import { computed, defineComponent } from 'vue';
import { useI18n } from 'vue-i18n';

export default defineComponent({
  name: 'IntegrationCollectionCard',
  props: {
    name: { type: String, required: true },
    icon: { type: String, default: null },
    count: { type: Number, default: 0 },
    status: { type: String, default: null },
    previews: { type: Array as () => string[], default: () => [] },
    // Défaut null → résolu via i18n dans le composant (G9, plus de 'PAR' figé).
    kicker: { type: String, default: null },
    countLabel: { type: String, default: '' },
    openLabel: { type: String, default: '' },
    installLabel: { type: String, default: '' },
  },
  emits: ['open'],
  setup(props) {
    const { t } = useI18n();

    // Kicker par défaut traduit (« PAR » / « BY ») quand la prop n'est pas fournie.
    const resolvedKicker = computed(() => props.kicker || t('integrations.collection.kicker'));

    // Always render 3 stack layers (fill missing with empty placeholders).
    const stackPreviews = computed(() => {
      const out = (props.previews || []).slice(0, 3);
      while (out.length < 3) out.push('');
      // Top layer first in DOM stacking order.
      return out;
    });
    return { stackPreviews, resolvedKicker };
  },
});
